export class ApplicationFormData {
    user: any;
    applicant: any;
}